<template>
  <div style="width: 100%">
    <v-data-table
        class="pa-0"
        :headers="headers"
        :items="items"
        :hide-default-header="items.length === 0"
        :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        hide-default-footer dense
        style="white-space: nowrap; overflow-x: scroll !important;">
      <template v-slot:top>
        <v-toolbar flat dense>
          <v-toolbar-title>Configs</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn @click="row_create" small class="ma-2" color="primary">New</v-btn>
          <v-spacer/>
        </v-toolbar>
      </template>
      <template v-slot:item.target="{item}">
        {{ getTargetName(item) }}
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small>mdi-content-copy</v-icon>
        <v-icon @click="row_moveup(item)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
        <v-icon @click="row_movedown(item)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <r-reward-generator-config-dialog ref="dialog" :view_flags="view_flags"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RewardGeneratorConfig} from "@/modules/redactor/models/reward-generator/RewardGeneratorConfig";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

import RRewardGeneratorConfigDialog from "@/modules/redactor/views/reward-generator/r-reward-generator-config-dialog.vue";

export default {
  name: "r-reward-generator-config-table",
  components: {RRewardGeneratorConfigDialog},
  props: {
    view_flags: VueTypes.integer.def(0xFFFF),
    items: VueTypes.arrayOf(RewardGeneratorConfig).isRequired
  },
  data: () => ({
    headers: [
      {text: 'Target', value: 'target'},
      {text: 'Amount', value: 'amount'},
      {text: 'Probability', value: 'percent'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  methods: {
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy())
          .then((data) => {
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
          .then((data) => {
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone())
          .then((data) => {
            const index = this.items.indexOf(item);
            this.items.splice(index, 1, data);
          }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      });
    },
    row_moveup(item) {
      const index = this.items.indexOf(item);
      if (index > 0) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },
    row_movedown(item) {
      const index = this.items.indexOf(item);
      if (index < this.items.length - 1) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    },

    getTargetName(item) {
      if (item.item) {
        return "[IT]  " + item.item.string + " (" + item.item.state.name + ")";
      } else if (item.itemCluster) {
        let value = RedactorUtils.getItemCluster(item.itemCluster);
        return value ? "[IC]  " + value.name : "error";
      } else if (item.card) {
        let value = RedactorUtils.getCard(item.card);
        return value ? "[CR]  " + value.name : "error";
      } else if (item.cardCluster) {
        let value = RedactorUtils.getCardCluster(item.cardCluster);
        return value ? "[CC]  " + value.name : "error";
      } else if (item.cardPackage) {
        let value = RedactorUtils.getCardPackage(item.cardPackage);
        return value ? "[CP]  " + value.name : "error";
      } else if (item.currencyKind) {
        return "[CK]  " + item.currencyKind.key;
      }

      return "ERROR";
    }
  }
}
</script>